<template>
	<div id="page">
	
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button> {{lableText('TasksName')??'وظایف'}} {{ $route.params.status}}</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>

			<div class="card card-style mb-2">
				<div class="content mb-0">
					<div class="list-group list-custom-small list-icon-0">
						<div class="list-group-div" @click.prevent="openDetails(task.taskFolderId,task.taskId)" v-for="task in reportListComputed" :key="task.taskFolderId">
							<div>
								<b class="font-13 text-dark">{{task.title}}</b>
								<span v-if="task.stepTitle!=null" class="badge bg-magenta2-light font-10 mt-2 float-left">
									{{task.stepTitle}}
								</span>
							</div>
							<div class="d-flex justify-content-between">
								<span class="text-muted text-left ltr">{{task.taskDate}}</span>
								<span>
									<i class="fa fa-hashtag color-blue2-dark ml-0"></i>
									<span class="text-muted">{{task.taskNo}}</span>
								</span>		
							</div>
							<div class="d-flex justify-content-between mb-2">
								<div class="d-flex justify-content-between" style="width:90%">
									<div>
										<!--اگر کاربر تصویر پروفایل نداشت-->
										<!--<i class="fa fa-user color-green2-light ml-0"></i>-->
										<!--تصویر پروفایل کاربر-->
										<!--<img src="/assets/images/bg10.jpg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />-->
										<img v-if="task.userReceiverImg!=null && task.userReceiverImg!=''" :src="task.userReceiverImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
										<i v-else class="fa fa-user-circle color-green2-light font-30 ml-2"></i>

										<span class="text-muted">{{task.userTitle}}</span>
									</div>									
								</div>
								<span class="text-left" style="width:10%" @click.stop="showMenu(task.taskFolderId,task.taskId)"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="loading==false && noMore==false && reportListComputed.length>0" class="card card-style">
				<div class="content">
					<div class="d-flex justify-content-center w-100">
						<button class="btn btn-outline-info rounded-m" @click="getNextPageForTaskStatusFolderList">نمایش بیشتر</button>
					</div>
				</div>
			</div>
			<div v-if="loading" class="card card-style">
				<div class="content">
					<div class="d-flex justify-content-center w-100">
						<div class="spinner-border color-magenta2-dark" role="status"></div>
					</div>
				</div>
			</div>
		</div>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-height="200" data-menu-effect="menu-over" style="height:200px; display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link class="d-flex justify-content-between align-items-center" :to="{ name: 'EditTask', params: { taskFolderId: selectedTaskFolderId,taskId:selectedTaskId  } }"><span><i class="fa fa-search color-green2-light float-right font-14"></i>جزئیات</span><i class="fa fa-angle-left"></i></router-link>
					<button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="CloseTaskFolder"><span class="d-inline-flex align-items-center"><i class="fa fa-times color-red1-light float-right font-14"></i>درخواست بستن</span><i class="fa fa-angle-left"></i></button>
					<button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="CanAddTaskWork"><span class="d-inline-flex align-items-center"><i class="fa fa-check-square color-blue2-light float-right font-14"></i>ثبت پیگیری</span><i class="fa fa-angle-left"></i></button>
				</div>
				<div class="clear"></div>
			</div>
		</div>
	</div>



</template>

<script>
import VueSimpleAlert from "vue3-simple-alert";
    export default {
        data() {
            return {
                page: 1,
                selectedTaskFolderId: 0,
				selectedTaskId: 0,
				reportList: [],
				noMore: false,
				loading:false
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
			},
            NoMoreData() {
                return this.$store.getters.GetOrgUnitReportListNoMoreData;
			},
			reportListComputed() {
				return this.reportList;
            }
        },
        created() {
			this.page = 1;
            this.GetOrgUnitTaskReportDetailsListFromServer({
                pageId: 1,
                orgCode: this.$route.params.orgCode,
                status: this.$route.params.status
            });
			
        },
        methods: {
            showMenu(taskFolderId, taskId) {
                this.selectedTaskFolderId = taskFolderId;
				this.selectedTaskId = taskId;
				document.getElementsByClassName("optionMenu")[0].click();
                console.log(taskFolderId, taskId);
			},
           
			CloseTaskFolder() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm("آیا مایل به بستن این "+(this.lableText('TaskName')??'وظیفه')+" هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$store.dispatch("CloseTaskFolder", {
						taskFolderId: this.selectedTaskFolderId
					});
				});
            },
            CanAddTaskWork() {
                this.$http.get("TaskWork/CanAddTaskWork?taskId=" + this.selectedTaskId + "&taskFolderId=" + this.selectedTaskFolderId)
                    .then(data => {
						var res = data.data;
						if (res != "1") {
                            this.showMessage(res);
						}
						else {
							this.$router.push({ name: 'CreateTaskWork', params: { taskFolderId: this.selectedTaskFolderId, taskId: this.selectedTaskId } })
                        }
                    });
			},
            openDetails(taskFolderId, taskId) {
                this.$router.push({ name: 'EditTask', params: { taskFolderId: taskFolderId, taskId: taskId } });
                document.getElementsByClassName('menu-hider')[0].click();
			},
            GetOrgUnitTaskReportDetailsListFromServer(Filter) {
				this.loading = true;
                this.$http.get("Report/GetTaskStatusReportDetails", {
                    params: {
                        orgCode: Filter.orgCode,
                        status: Filter.status,
                        page: Filter.pageId
                    }
                }).then(data => {
					this.loading = false;
                    if (data.data.length == 0) {
						this.noMore = true;
                    }
                    else {
						this.noMore = false;
                    }

                    if (Filter.pageId === 1) {
						this.reportList = data.data;
                    }
					else {
						this.reportList.push.apply(this.reportList, data.data);

                    }
					this.loading = false;
                });
            },
			getNextPageForTaskStatusFolderList() {
						this.page++;
						console.log(this.page);
                        this.GetOrgUnitTaskReportDetailsListFromServer({
                            pageId: this.page,
                            orgCode: this.$route.params.orgCode,
                            status: this.$route.params.status
                        });
			},
			
		},
		mounted() {
            this.page = 1;
			console.log("mounted"); 
			document
				.querySelectorAll(".menu-box-right")
				.forEach((a) => (a.style.display = "block"));
           // this.getNextPageForTaskStatusFolderList();
		},
       
	};</script>
